<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>

<div class="container" style="margin-top:10px">
    <div class="row" *ngIf="userrole === 0">
        <div class="col-12 text-center" style="margin:5px">
          <button class="btn btn-success btn-block" style=" border-radius:15px" (click)="asktoVet()">Ask Our Vetenerian</button>
        </div>
        </div>
  <div class="row">
    <div class="col-12 text-left">
      <h4><p style="overflow-wrap: break-word; font-style: open sans;
        color:#9b7544">Forum/Home/{{cat}}</p></h4> 
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8" *ngIf="forum && forum.length> 0">
      <div class="row"  *ngIf="loadall === 0; else loadallforum">
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:5px"
         *ngFor=" let data of forum | slice: 0 : (forum.length - forum.length) + 6 ">
          <div class="card" style="width:100%">
            <div class="card-header">
              <div class="row">
                <div class="col-6 text-left">
                  {{data.updated_at}}
                </div>
                <div class="col-6 text-right">
                    <i class="fa fa-comment-o" aria-hidden="true"></i> {{commentsarray['id' + data.id]}}  
                  </div>
              </div>
            </div>
            <div class="card-body">
              <div class="single_comment_area">
                  <div class="comment-wrapper d-flex">
                      <!-- Comment Meta -->
                      <div class="comment-author">
                          <img src="https://passport.petcart.in/images/blogimage/forum.jpg" alt="">
                      </div>
                      <!-- Comment Content -->
                      <div class="comment-content">
                          <h4>  <p style="overflow-wrap: break-word"> {{data.title}} </p> </h4> 
                          <h5> <p style="overflow-wrap: break-word"> {{data.body | slice:0:20}}</p></h5>  
                      </div>
                  </div>
              </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-12 text-right">
                <button class="btn btn-secondary contact-btn" routerLink="/forum/forumdetail/{{data.id}}">Detail</button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="row" style="margin:5px" *ngIf="loadall === 0">
        <div class="col-4 text-center">
          <button class="btn-success btn-block" style="border-radius:15px" (click)="loadAll()">Load All</button>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center">
      <div class="card" style="border-radius:30px;border: 1px solid #cd983f;margin-top:5px "
      *ngIf="forum && forum.length> 0">
          <div class="filter-header text-center" style="    border-radius: 20px 20px 0 0;">
              Categories  
             </div>  
        <div *ngIf="forum && forum.length > 0">
            <div *ngFor="let datan of forum | uniquefilterforum : 'category'">
                <p class="filterel" (click)="filterbyCategory(datan.category)">{{datan.category}} ({{categoryCount(datan.category)}})</p>
           </div>
          </div>
          <div *ngIf="breed && forum">
              <div class="filter-header text-center">
                      Pet Type  
       </div>  
            <div  *ngFor= "let data of breed">
               <div *ngFor="let datan of forum | uniquefilterforum  : 'pet_type'">
                 <div *ngIf="datan.pet_type == data.id" >
                   <p class="filterel" (click)=" filterbyPet_type(datan.pet_type, data.name)"  >{{data.name}} ({{pettypeCount(datan.pet_type)}})</p>
              </div>
             </div>
           </div>
         </div> 
         <div *ngIf="breed && forum">
            <div class="filter-header text-center" >
                    Breed  
                     </div> 
       <div  *ngFor= "let data of breed">
          <div *ngFor="let datan of forum | uniquefilterforum : 'breed_id'">
            <div *ngIf="data.id === datan.breed_id">
              <p class="filterel" (click)=" filterbyBreed(datan.breed_id,data.name)">{{data.name}} ({{breedCount(datan.breed_id)}})</p>
         </div>
        </div>
      </div>
    </div> 
    <div *ngIf="lifestage && forum">
        <div class="filter-header text-center" >
                Pet Lifestage  
                 </div> 
      <div  *ngFor= "let data of lifestage">
         <div *ngFor="let datan of forum  | uniquefilterforum : 'lifestage_id'">
           <div *ngIf="datan.lifestage_id == data.id">
             <p class="filterel" (click)="  filterbyLifestage(datan.lifestage_id,data.name)" >{{data.name}} ({{lifestageCount(datan.lifestage_id)}})</p>
        </div>
       </div>
     </div>
   </div>  
   <div class="card-footer" style="margin:5px"
    *ngIf="lifestagefilter || breedfilter || pettypefilter || categoryfilter">
     <div class="row">
       <div class="col-12">
        <button class="btn btn-success2 btn-block" style="border-radius:15px" (click)="reset()">
          Reset
        </button>
       </div>
     </div>
   </div>
      </div>
    </div>
  </div>
</div>
 <ng-template #loadallforum>
   <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:5px"
    *ngFor=" let data of forum | breedforum:  breedfilter | pettypeforum:  pettypefilter
    | lifestageforum: lifestagefilter | cateforyforum : categoryfilter| paginate: { itemsPerPage: 6, currentPage: p }">
     <div class="card" style="width:100%">
       <div class="card-header">
         <div class="row">
           <div class="col-6 text-left">
             {{data.updated_at}}
           </div>
           <div class="col-6 text-right">
               <i class="fa fa-comment-o" aria-hidden="true"></i> {{commentsarray['id' + data.id]}}  
             </div>
         </div>
       </div>
       <div class="card-body">
         <div class="single_comment_area">
             <div class="comment-wrapper d-flex">
                 <!-- Comment Meta -->
                 <div class="comment-author">
                     <img src="https://passport.petcart.in/images/blogimage/forum.jpg" alt="">
                 </div>
                 <!-- Comment Content -->
                 <div class="comment-content">
                     <h4>  <p style="overflow-wrap: break-word"> {{data.title}} </p> </h4> 
                     <h5> <p style="overflow-wrap: break-word"> {{data.body | slice:0:20}}</p></h5>  
                 </div>
             </div>
         </div>
     </div>
     <div class="card-footer">
      <div class="row">
        <div class="col-12 text-right">
          <button class="btn btn-secondary contact-btn" routerLink="/forum/forumdetail/{{data.id}}">Detail</button>
        </div>
      </div>
    </div>
   </div>
   </div>
  </div>
  <div class="row" *ngIf="forum && forum.length> 0">
    <div class="col-12 text-right">
        <pagination-controls  (pageChange)="p = $event" ></pagination-controls >
    </div>
  </div>
 </ng-template>